class ProductSwatches extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.product-swatches__container');
    this.availableColorsContainer = this.querySelector('.product-grid-item__siblings-available');

    this.settings = this.setSettings();
    var hideIfEmpty = this.settings.hideIfEmpty;
    if (this.settings.groupTag) {
      fetch(`/collections/all/${encodeURIComponent(this.settings.groupTag).replace('.', '-')}?view=data`)
        .then((response) => {
          if (response.ok == false) {
            return [];
          }
          return response.json();
        })
        .then((responseJson) => {
          this.initSwatches(responseJson);
          this.setCurrent(this.settings.colour);
          this.hideIfEmpty(hideIfEmpty)
          this.addEventListener();
        }).catch(err => {
          console.error(err)
        });
    } else {
      this.hideIfEmpty(hideIfEmpty);
      this.initSwatches([])
    }
  }

  addEventListener() {
    if (document.querySelector('[data-href-select]')) {
      document.querySelector('[data-href-select]').addEventListener('change', function (e) {
        var href = e.target.options[e.target.selectedIndex].dataset.href;
        window.location.href = href;
      });
    }
  }

  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return;
    const availableSwatches = this.querySelectorAll('.product-swatches__container [data-available="true"]');
    if (availableSwatches.length == 0) {
      this.classList.add("swatch-empty--hide");
    };

  }

  setSettings() {
    const settingsRawJson = this.querySelector("#swatches-settings");
    if (!settingsRawJson) return {}
    return JSON.parse(settingsRawJson.innerHTML);
  }

  initSwatches(products) {
    var html = "";
    var sliderItems = "";
    if (products.length < 2) return;

    if (products.length) {
      var optionsObject = {}
      for (const option of this.settings.swatchOptions) {
        optionsObject[`${option}`] = [...new Set(products.map(p => p[`${option}`]))].filter(n => n)
      }
      for (const option in optionsObject) {
        var isSliderType = ["Flavour", "Flavor", "flavor", "flavour"].includes(option);//define slider elements
        if (optionsObject[`${option}`].length == 0) continue
        if (optionsObject[`${option}`].length == 1 && this.settings.skipOneOption) continue
        html = html + `<legend class="form__label option--label">${option.replace("_", " ")}: <b>${this.settings[`${option}`]}</b> <span class="option--value" data-${option}-option></span></legend> <div data-row-${option} class="product-swatches__container-row ${isSliderType ? 'sliderType' : ''}" >`

        if (this.settings.type == 'dropdown' && !isSliderType) {
          html = html + `<div class="select"><select class="select__select" data-href-select>`
        }
        for (const optionValue of optionsObject[`${option}`]) {

          var potentialProducts = products.filter(p => p[`${option}`] == optionValue);
          if (!potentialProducts.length) continue;
          var product = potentialProducts[0];
          if (potentialProducts.length > 0) {
            for (const innerOption of this.settings.swatchOptions) {
              if (innerOption == option) continue;
              potentialProducts = potentialProducts.filter(p => p[`${innerOption}`] == this.settings[`${innerOption}`])
            }
            product = potentialProducts[0]
          }

          var firstAvailableVariant = null;
          if (!product) continue;
          for (const v of product.variants) {
            if (v.inventory_quantity > 0) {
              firstAvailableVariant = v;
              break;
            }
          }
          var img = this.getProductImage(product, option);

          const optionValueHtml = `<p class="variant-title">${optionValue}</p>`;
          if (this.settings.type == 'dropdown' && !isSliderType) {
            html = html + `<option class="product-swatches__container" data-available="${firstAvailableVariant ? "true" : "false"}" data-selected="${product.handle == this.settings.currentProductHandle}" data-handle="${product.handle}" data-href="/products/${product.handle}">
                ${img}
                </option>`;
          }
          const el = `
            <div class="swatch-option-container ${isSliderType ? 'swiper-slide slider__slide' : ''} ${this.settings.type}">
                <a class="${isSliderType ? 'label__flavour' : ''} product-swatches__container" data-available="${firstAvailableVariant ? "true" : "false"}" data-selected="${product.handle == this.settings.currentProductHandle}" data-handle="${product.handle}" href="/products/${product.handle}">
                ${isSliderType ? optionValueHtml : ""}
                ${img}
                </a>
            </div>`;

          if (isSliderType) {
            sliderItems += el;
          } else {
            html += el;
          }
        }

        document.querySelector("[data-flavour-slider-items]").innerHTML = sliderItems;

        sliderItems = "";//reset;

        if (this.settings.type == 'dropdown' && !isSliderType) {
          html = html + `
            </select>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
            </svg>
            </div>`
        }
        html = html + "</div>"
      }
      if (this.availableColorsContainer) {
        const totalColours = [...new Set(products.map(prod => prod.colour))].length
        this.availableColorsContainer.innerHTML = `${totalColours} colour${totalColours > 1 ? 's available ' : ' available'}`
      }
    } else {
      // this.availableColorsContainer.innerHTML = `1 colour available`
      // html = `<a class="empty-swatch" data-available="true" class="selected" data-handle="${this.settings.currentProductHandle}" href="/products/${this.settings.currentProductHandle}"><span data-option-name="colour" data-colour-transparent> </span></a>`
    }
    if (html) {
      this.container.innerHTML = html
    }
  }


  getProductImage(product, option) {
    var imageSrc = product.featured_image;
    var image = `<img src="${product.featured_image}" loading="lazy" width="80" height="80">`;
    if (option != "Size") {
      switch (this.settings.image_type) {
        case "metafield_swatch":
          const metafieldImage = product.swatch_image;
          if (metafieldImage) image = metafieldImage;
          break;
        case "image_swatch":
          const o = product[option];
          if (o) {
            const colour = o.toLowerCase().replace(/ /g, "").replace(/ /g, "-").toLowerCase();
            image = `<span data-option-name="${option}" data-${option}-${colour.toLowerCase()}> </span>`
          } else {
            image = ``
          }
          break;
        case "featured_image":
          const featuredImage = product.featured_image;
          if (featuredImage) image = `<img src="${featuredImage}" loading="lazy">`;
          break;
        case "first_variant_image":
          const firstVariantImage = product.variants[0].image;
          if (firstVariantImage) image = `<img src="${firstVariantImage}" loading="lazy">`;
          break;
        case "last_variant_image":
          const lastVariantImg = product.variants[product.variants.length - 1].image;
          if (lastVariantImg) image = `<img src="${lastVariantImg}" loading="lazy">`;
          break;
        default:
          break;
      }
    } else {
      return product[`${option}`]
    }
    return image;
  }

  setCurrent(colour) {
    var elements = this.container.querySelectorAll(`[data-handle="${window.current.product.handle}"]`)
    if (window.current.product.handle && elements.length) {
      elements.forEach(element => {
        element.classList.add("selected");
        element.setAttribute("selected", true);
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  customElements.define('product-swatches', ProductSwatches);
});



let flavourArr = document.querySelectorAll('.product-form__input--flavour .slider__slide');
let faqsArr = document.querySelectorAll('.pdp-faqs');
let itemProduct = document.querySelector('.js-pdp-faqs--product')

faqsArr.forEach(element => {
  if (element.dataset.faq) {
    if (element.dataset.faq.includes(flavourArr[0].dataset.id)) {
      element.classList.add('pdp-faqs--variant-active')
      itemProduct.classList.remove('pdp-faqs--product-active')
    }
    else {
      if (itemProduct) {
        itemProduct.classList.add('pdp-faqs--product-active')
      }
    }
  }

});

flavourArr.forEach(elem => {
  elem.addEventListener("click", function () {
    faqsArr.forEach(element => {
      if (element.dataset.faq.includes(elem.dataset.id)) {
        element.classList.add('pdp-faqs--variant-active');
        itemProduct.classList.remove('pdp-faqs--product-active');
      }
      else {
        if (itemProduct) {
          element.classList.remove('pdp-faqs--variant-active');
          itemProduct.classList.add('pdp-faqs--product-active');
        }
      }

      if (document.querySelector('.pdp-faqs--variant-active')) {
        itemProduct.classList.remove('pdp-faqs--product-active');
      }
    });

  });
});
